// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';
import { hasNav } from '../../helpers';

export const MenuServicesWrapper = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.shades[7]};
  list-style: none;
  right: 0;
  top: 100%;
  border-bottom-left-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  border-bottom-right-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  max-width: 715px;
  width: 100%;
  overflow: hidden;
`;

const MainServices = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.message.hover};
`;

const SubServices = styled.div`
  display: flex;
`;

const Box = styled.div`
  flex: 1;
  padding: 24px 40px 22px 0;

  &:first-child {
    padding-left: 40px;
  }
`;

const LabelLink = styled(Link)`
  display: block;
  position: relative;
  color: ${({ theme }) => theme.colors.header.nav.desktop.titleMain};
  font-size: inherit;
  width: 195px;
  font-weight: 600;
  margin-bottom: 16px;
  ${({ href }) => (!href || href.length <= 1 ? 'pointer-events: none;' : '')}
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
`;

const ListItem = styled.li`
  padding: 0 0 15px;

  &:last-child {
    padding-bottom: 0;
  }
`;

const ListType = styled.ul`
  display: flex;
  padding: 5px 0 0;
`;

const TypeItem = styled.li`
  position: relative;
  display: flex;
  padding: 0 5px;

  &:after {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-left: 1px solid ${({ theme }) => theme.colors.header.nav.desktop.titleMain};
    height: 10px;
  }

  &:first-child {
    padding-left: 0;

    &:after {
      display: none;
    }
  }
`;

const TypeLink = styled(Link)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.header.nav.desktop.titleMain};
  font-size: 12px;
`;

const renderNavigation = nav => (
  nav.map((items, i) => (
    <Box key={i}>
      <LabelLink href={items.link}>{items.label}</LabelLink>
      <List>
        {
          hasNav(items) && items.nav.map((item, j) => (
            <ListItem key={j}>
              <Link href={item.link}>
                {item.label}
              </Link>
              <ListType>
                {
                  hasNav(item) && item.nav.map((type, k) => (
                    <TypeItem key={k}>
                      <TypeLink href={item.link}>
                        {type.label}
                      </TypeLink>
                    </TypeItem>
                  ))
                }
              </ListType>
            </ListItem>
          ))
        }
      </List>
    </Box>
  ))
);

const MenuServices = (props) => {
  const { data } = props;
  return (
    <MenuServicesWrapper>
      <MainServices>
        {renderNavigation(data[0].nav)}
      </MainServices>
      <SubServices>
        {renderNavigation(data[1].nav)}
      </SubServices>
    </MenuServicesWrapper>
  );
};

MenuServices.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
      style: PropTypes.string,
      nav: PropTypes.arrayOf(PropTypes.shape({
        nav: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.string
        }))
      }))
    })
  ).isRequired
};

export default MenuServices;
